module.exports = __webpack_public_path__ + "img/user-large.59300685.svg";